<template>
    <cic-popup class="keypad" title="Keypad" @blur="$emit('blur')">
        <cic-button
            v-for="key in ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#']"
            :key="key"
            :enabled="!keys.includes(key)"
            @click="$emit('click', key)"
        >
            {{ key }}
        </cic-button>
    </cic-popup>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicPopup from '@/components/CicPopup';

    export default {
        name: 'KeyPad',
        components: { CicPopup, CicButton },
        props: {
            keys: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur', 'click'],
    };
</script>
